export const checkIsScrolledToBottom = (el: HTMLElement) => {
  return el.scrollHeight - el.scrollTop <= el.clientHeight + 10;
};

export const checkIsScrolledToTop = (el: HTMLElement) => {
  return el.scrollTop === 0;
};
